import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import UserService from '../../services/userServices';
import userInterface from '../../models/user.interface';
import marginTopAllComponent from "../../utils/styleGlobal";

const UserEditPage = ({ setAlert }) => {
  const { userId } = useParams();
  const { isLogged } = useContext(AuthContext);
  const navigate = useNavigate();
  const [user, setUser] = useState({ ...userInterface });

  useEffect(() => {
    if (!isLogged) return;
    if (userId) {
      UserService.getOne(userId)
        .then((res) => {
          setUser(res.data.data);
        })
        .catch((err) => console.error('Erreur lors de la récupération de l\'utilisateur :', err));
    } else {
      setUser({ nom: '', prenom: '', email: '', role: '3', tel: '', adresse: '', photo: '' });
    }
  }, [isLogged, userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };



  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    if (!isValidEmail(user.email)) {
      setAlert({ type: 'danger', message: 'Email invalide.' });
      return false;
    }
    if (user.role !== '3' && user.role !== 3) {
      if (!user.password || user.password.length < 8) {
        setAlert({ type: 'danger', message: 'Le mot de passe doit contenir au moins 8 caractères.' });
        return false;
      }

      if (user.password !== user.passwordConfirm) {
        setAlert({ type: 'danger', message: 'Les mots de passe ne correspondent pas.' });
        return false;
      }
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (userId) {
      UserService.update(userId, user)
        .then((res) => {
          console.log(res);

          setAlert({ type: "success", message: "Données chargées avec succès!" });
          navigate('/user/list');
        })
        .catch((err) => {
          console.log(err);

          setAlert({ type: "danger", message: "Erreur lors de la mise à jour de l'utilisateur!" });
          console.error('Erreur lors de la mise à jour de l\'utilisateur :', err)
        });
    } else {
      if ((user.role !== '3'  && user.role !== 3) && (!user.password || user.password.length < 8)) {
        setAlert({ type: 'danger', message: 'Le mot de passe est requis (8 caractères minimum).' });
        return;
      }
      UserService.create(user)
        .then((res) => {
          console.log(res.data);

          setAlert({ type: "success", message: "Utilisateur inséré avec succès!" });
          navigate('/user/list');
        })
        .catch((err) => {
          setAlert({ type: "danger", message: "Erreur lors de la création de l'utilisateur!" });
          console.error('Erreur lors de la création de l\'utilisateur :', err)
        });
    }
  };



  return (
    <div
      className="container"
      style={{
        marginTop: marginTopAllComponent(),
        marginBottom: marginTopAllComponent(),
        maxWidth: "600px",
        padding: "20px",
        backgroundColor: "#f8f9fa",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        height: "auto",
        minHeight: "70vh",
      }}
    >
      <h2 className="text-center mb-4">{userId ? 'Modifier l\'utilisateur' : 'Créer un utilisateur'}</h2>

      {isLogged ? (
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="nom" className="form-label">Nom</label>
            <input
              type="text"
              name="nom"
              id="nom"
              className="form-control"
              placeholder="Entrez le nom"
              value={user.nom}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="prenom" className="form-label">Prénom</label>
            <input
              type="text"
              name="prenom"
              id="prenom"
              className="form-control"
              placeholder="Entrez le prénom"
              value={user.prenom}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              className="form-control"
              placeholder="Entrez l'email"
              value={user.email}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="tel" className="form-label">Téléphone</label>
            <input
              type="text"
              name="tel"
              id="tel"
              className="form-control"
              placeholder="Entrez le numéro de téléphone"
              value={user.tel}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="adresse" className="form-label">Adresse</label>
            <input
              type="text"
              name="adresse"
              id="adresse"
              className="form-control"
              placeholder="Entrez l'adresse"
              value={user.adresse}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="role" className="form-label">Rôle</label>
            <select
              name="role"
              id="role"
              className="form-control"
              value={user.role}
              onChange={handleChange}
              required
            >
              <option value="1">Admin</option>
              <option value="2">Superviseur</option>
              <option value="3">Utilisateur</option>
            </select>
          </div>

          {(user.role !== '3' && user.role !== 3) && (
            <>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">Mot de passe</label>
                <input type="password" name="password" className="form-control" value={user.password} onChange={handleChange} required={!userId} />
              </div>
              <div className="mb-3">
                <label htmlFor="passwordConfirm" className="form-label">Confirmation</label>
                <input type="password" name="passwordConfirm" className="form-control" value={user.passwordConfirm} onChange={handleChange} required={!userId} />
              </div>
            </>
          )}

          <div className="mb-3 d-flex gap-2">
            <button type="submit" className="btn btn-primary w-100">{userId ? 'Enregistrer' : 'Créer'}</button>
            <button type="button" className="btn btn-dark w-100" onClick={() => navigate('/user/list')}>Annuler</button>
          </div>
        </form>
      ) : (
        <p className="text-danger text-center">Vous devez être connecté pour accéder à cette page.</p>
      )}
    </div>
  );
};

export default UserEditPage;
